import React from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Img from "../lazyLoadImage/Img";
import CircleRating from "../circleRating/CircleRating";
import Genres from "../genres/Genres";
import PosterFallback from "../../assets/no-poster.png";
import "./Card.scss";
import dayjs from "dayjs";

const Card = ({ data, mediaType, fromSearch }) => {
  const { url } = useSelector((state) => state.api);
  const navigate = useNavigate();
  const posterUrl = data.poster_path
      ? url.poster + data.poster_path
      : PosterFallback;

  return (
    <div
            className={"card"}
            onClick={() =>
                navigate(`/${data.media_type || mediaType}/${data.id}`)
            }
        >
            <div className={"posterBlock"}>
                <Img className={"posterImg"} src={posterUrl} />
                {!fromSearch && (
                    <React.Fragment>
                        <CircleRating rating={data.vote_average.toFixed(1)} />
                        <Genres data={data.genre_ids.slice(0, 2)} />
                    </React.Fragment>
                )}
            </div>
            <div className={"textBlock"}>
                <span className={"title"}>{data.title || data.name}</span>
                <span className={"date"}>
                    {dayjs(data.release_date).format("MMM D, YYYY")}
                </span>
            </div>
        </div>
  )
}

export default Card;